// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



export const environment = {
    adClient: 'ca-pub-XYZ',
    google_analytics_key: 'G-PTP6T2Y5L6',
    appVersion: require('../../../../package.json').version + '-dev',
    production: false,
    isLocal: false,
    enableServiceWorker: true,
    enableFuse: true,
    // Per-user rewarded ad-free: short in dev so the cycle is quick to test.
    adFreeDurationMs: 30000,
    rewardedAdDummyDurationMs: 5000,
    // AppLixir rewarded-video SDK (Step 2). Client-side key (embedded in the
    // bundle, not a secret).
    applixirApiKey: '10db9b18-e2e5-4f38-a91f-af35f1b81e12',
    debug_log: true,
    ngxLoggerLevel: 1,
    ngxServerLoggerLevel: 5,
    brandName: 'ScrumpokerDEV',
    home_button_label: 'ScrumPoker-online.dev',
    home_button_label_short: 'ScrumPoker-online',
    host: 'staging.scrumpoker-online.org',
    host_url: 'https://staging.scrumpoker-online.org',
    whoodleUrl: 'https://www.whocan.org',
    useEmulators: false,


    firebase: {
        apiKey: 'AIzaSyAuaOYgzBsWcKnVSK7Hy6AJk6cJHnIHCfs',
        authDomain: 'staging.scrumpoker-online.org',
        databaseURL: 'https://ng-scrum-poker-kp1.firebaseio.com',
        functionsUrl: 'https://us-central1-ng-scrum-poker-kp1.cloudfunctions.net',
        projectId: 'ng-scrum-poker-kp1',
        storageBucket: 'ng-scrum-poker-kp1.appspot.com',
        messagingSenderId: '835583700972',

    }

};



/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
